/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core';
import FlexBox from 'components/atoms/FlexBox';
import Checkbox from 'components/molecules/Checkbox';
import DateRangePicker from 'components/molecules/DateRangePicker';
import SelectForm from 'components/molecules/SelectForm';
import { ManagerDataStaffDomain } from 'domain/master/general/managerDataStaff';
import { useManagerEdit } from './hooks';
import SubActionButton from 'components/atoms/Button/SubActionButton';
import CalendarRangeV2 from 'components/molecules/CalendarV1/CalendarRangeV2';
import Calendar from 'components/molecules/CalendarV1';

const styles = {
  undecidedCheckBox: css({
    padding: '6px 8px',
  }),
  checkbox: css({
    paddingLeft: '15px',
  })
};

const OrganizationManagerEdit: React.FC<{
  manager: ManagerDataStaffDomain;
  setManager: (manager: ManagerDataStaffDomain) => void;
  deleteManager: () => void;
}> = ({
  manager, deleteManager, setManager,
}) => {
    const {
      isEndDateUndecided,
      toggleEndDateUndecided,
      // type,
      changeStartDate,
      changeEndDate,
      changeType,
    } = useManagerEdit(manager, setManager);
    return (
      <tr>
        <td style={{ textAlign: 'center' }}>
          <SubActionButton action={1} text="削除" onClick={deleteManager} />
        </td>
        <td>{manager.orgName}</td>
        <td>
          <SelectForm
            label=""
            name="orgCode"
            width="100%"
            isHiddenLabel={true}
            value={String(0)}
            setValue={(v) => {
              changeType(Number(v));
            }}
            options={[
              {
                label: 'マネージャー',
                value: '0',
              },
              // {
              //   label: 'シニアマネージャー',
              //   value: '1',
              // },
            ]}
          />
        </td>
        <td>
          <FlexBox>
            {/* <DateRangePicker
              startDate={manager.startDate}
              setStartDate={changeStartDate}
              endDate={manager.endDate ? manager.endDate : undefined}
              setEndDate={changeEndDate}
              endDateDisabled={isEndDateUndecided}
              showCharEquivalent={true}
            /> */}
            <CalendarRangeV2 
              startDate={manager.startDate}
              endDate={manager.endDate ? manager.endDate : undefined}
              onChangeStart={changeStartDate}
              onChangeEnd={changeEndDate}
              canNullEndDate={true}
            />
            {/* {isEndDateUndecided ? 
              <Calendar 
                date={manager.startDate}
                setDate={(date) =>{
                  if(date){
                    changeStartDate(date)
                  }
                }}
              /> : 
              <CalendarRangeV2 
                startDate={manager.startDate}
                endDate={manager.endDate ? manager.endDate : undefined}
                onChangeStart={changeStartDate}
                onChangeEnd={changeEndDate}
              />
            } */}
            <div css={styles.checkbox}>
              <Checkbox
                id={JSON.stringify(manager)}
                name={JSON.stringify(manager)}
                label="未定"
                value="check"
                checked={isEndDateUndecided}
                onChange={toggleEndDateUndecided}
              />
            </div>
          </FlexBox>
        </td>
      </tr>
    );
  };

export default OrganizationManagerEdit;
